import { Edit, Trash2, BarChart3 } from "lucide-react";
import Button from "../common/Button";

const JobManagementCard = ({ job, onNavigate, onStatusToggle, onDelete, onViewScoring }) => {
    const getStatusBadge = (status) => {
        const styles = { active: 'bg-green-100 text-green-700', draft: 'bg-yellow-100 text-yellow-700', closed: 'bg-red-100 text-red-800' };
        return <span className={`px-3 py-1 rounded-full text-xs font-medium ${styles[status] || 'bg-gray-100 text-gray-700'}`}>{status?.charAt(0).toUpperCase() + status?.slice(1)}</span>;
    };

    return (
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row justify-between gap-4">
                <div className="flex-1">
                    <h3 className="font-bold text-lg text-secondary-900">{job.title}</h3>
                    <div className="flex items-center gap-4 text-sm text-secondary-600 mt-1">
                        <span>{job.location}</span>
                        <span>•</span>
                        <span>{getStatusBadge(job.status)}</span>
                    </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                    <Button variant="outline" size="sm" onClick={() => onNavigate(`/post-job?edit=${job.id}`)} icon={<Edit className="w-4 h-4" />} />
                    <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50" onClick={() => onDelete(job)} icon={<Trash2 className="w-4 h-4" />} />
                </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4 pt-4 border-t border-gray-100 text-center">
                <div>
                    <p className="font-bold text-secondary-800">{job.applicants_count || 0}</p>
                    <p className="text-xs text-secondary-600">Applicants</p>
                </div>
                <div>
                    <p className="font-bold text-secondary-800">{job.views || 0}</p>
                    <p className="text-xs text-secondary-600">Views</p>
                </div>
                <div>
                    <p className="font-bold text-secondary-800">{new Date(job.created_at).toLocaleDateString()}</p>
                    <p className="text-xs text-secondary-600">Posted On</p>
                </div>
                 <div className="flex flex-col sm:flex-row gap-2 justify-center">
                    <Button size="sm" onClick={() => onNavigate(`/view-applications/${job.id}`)}>
                        View Applicants
                    </Button>
                    <Button 
                        size="sm" 
                        variant="outline"
                        onClick={() => onViewScoring(job.id)}
                        icon={<BarChart3 className="w-4 h-4" />}
                    >
                        Scoring
                    </Button>
                </div>
            </div>
        </div>
    )
};

export default JobManagementCard;